<template>
  <div>
    <v-app-bar app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-tabs background-color="transparent" class="mr-12">
        <v-tab to="/designRequestManagement" v-show="isViewSale && !isAdmin">
          <v-badge :color="numberDesignRequest > 0 ? 'red' : 'transparent'" :content="numberDesignRequest">
            {{ $t('menu.design_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/manufactureRequestManagement" v-show="isViewSale && !isAdmin">
          <v-badge :color="numberManufactureRequest > 0 ? 'red' : 'transparent'" :content="numberManufactureRequest">
            {{ $t('menu.production_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/processingRequestManagement" v-show="isViewSale && !isAdmin">
          <v-badge :color="numberProcessingRequest > 0 ? 'red' : 'transparent'" :content="numberProcessingRequest">
            {{ $t('menu.waiting_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/finishRequestManagement" v-show="isViewSale && !isAdmin">
          <v-badge :color="numberFinishRequest > 0 ? 'red' : 'transparent'" :content="numberFinishRequest">
            {{ $t('menu.finish_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/notificationManagement" v-show="isViewSale && !isAdmin" @click="updateTotalNotify()">
          <v-badge :color="totalNumber > 0 ? 'red' : 'transparent'" :content="totalNumber">
            {{ $t('menu.notification') }}
          </v-badge>
        </v-tab>
        <!-- <v-tab v-for="tab of saleTab" :key="tab.id">
            <v-list-item :to="tab.link"> {{tab.name}} </v-list-item>
            </v-tab> -->
        <v-tab to="/designerDesignRequest" v-show="isViewDesigner  && !isAdmin">
          <v-badge :color="numberDesignRequest > 0 ? 'red' : 'transparent'" :content="numberDesignRequest">
            {{ $t('menu.design_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/designerManufactureRequest" v-show="isViewDesigner  && !isAdmin">
          <v-badge :color="numberManufactureRequest > 0 ? 'red' : 'transparent'" :content="numberManufactureRequest">
            {{ $t('menu.production_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/designerProcessingRequest" v-show="isViewDesigner  && !isAdmin">
          <v-badge :color="numberProcessingRequest > 0 ? 'red' : 'transparent'" :content="numberProcessingRequest">
            {{ $t('menu.waiting_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/designerFinishedRequest" v-show="isViewDesigner  && !isAdmin">
          <v-badge :color="numberFinishRequest > 0 ? 'red' : 'transparent'" :content="numberFinishRequest">
            {{ $t('menu.finish_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/notificationManagement" v-show="isViewDesigner && !isAdmin" @click="updateTotalNotify()">
          <v-badge :color="totalNumber > 0 ? 'red' : 'transparent'" :content="totalNumber">
            {{ $t('menu.notification') }}
          </v-badge>
        </v-tab>

        <v-tab to="/accountantManufactureRequest" v-show="isViewAccountant && !isAdmin">
          <v-badge :color="numberManufactureRequest > 0 ? 'red' : 'transparent'" :content="numberManufactureRequest">
            {{ $t('menu.production_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/accountantProcessingRequest" v-show="isViewAccountant && !isAdmin">
          <v-badge :color="numberProcessingRequest > 0 ? 'red' : 'transparent'" :content="numberProcessingRequest">
            {{ $t('menu.waiting_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/accountantPendingRequest" v-show="isViewAccountant && !isAdmin">
          <v-badge :color="numberPendingRequest > 0 ? 'red' : 'transparent'" :content="numberPendingRequest">
            {{ $t('menu.pending_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/accountantFinishRequest" v-show="isViewAccountant && !isAdmin">
          <v-badge :color="numberFinishRequest > 0 ? 'red' : 'transparent'" :content="numberFinishRequest">
            {{ $t('menu.finish_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/notificationManagement" v-show="isViewAccountant && !isAdmin" @click="updateTotalNotify()">
          <v-badge :color="totalNumber > 0 ? 'red' : 'transparent'" :content="totalNumber">
            {{ $t('menu.notification') }}
          </v-badge>
        </v-tab>

        <v-tab to="/logisticRequestManagement" v-show="isViewLogisticRequest && !isAdmin">
          <v-badge :color="numberShipRequest > 0 ? 'red' : 'transparent'" :content="numberShipRequest">
            {{ $t('menu.logistic_request') }}
          </v-badge>
        </v-tab>
        <v-tab to="/notificationManagement" v-show="isViewLogisticRequest && !isAdmin" @click="updateTotalNotify()">
          <v-badge :color="totalNumber > 0 ? 'red' : 'transparent'" :content="totalNumber">
            {{ $t('menu.notification') }}
          </v-badge>
        </v-tab>
      </v-tabs>

      <v-spacer></v-spacer>

      <div class="titleName"> {{ user.nickname }}</div>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-avatar dark v-on="on" size="45px">
            <img v-if="avatar" :src="avatar"/>
            <img v-else src='@/assets/avatar_default.png'/>
          </v-avatar>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in menus" :key="index" @click="selectItem(index)">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <div class="d-flex flex-row align-stretch">
        <!-- temporary -->
        <v-navigation-drawer v-model="drawer" temporary absolute width="400px" overlay-color="primary"
                             style="position:fixed; top:0; left:0; overflow-y:scroll;">
          <v-list>
            <template>
              <v-list-group prepend-icon="account_tree" no-action v-show="isViewOrganization">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.organization')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="(subItem, index) in navigation.organization" :key="subItem.title"
                             @click="selectMenuOrganization(index)">
                  <v-list-item-content>
                    <v-list-item-title v-text="subItem.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list-group>
            </template>

            <template>
              <v-list-group prepend-icon="security" no-action v-show="isViewPermission">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.permission_manager')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="(subItem, index) in navigation.permission" :key="subItem.title"
                             @click="selectMenuPermission(index)">
                  <v-list-item-content>
                    <v-list-item-title v-text="subItem.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list-group>
            </template>

            <template>
              <v-list-group prepend-icon="place" no-action v-show="isViewLocationAssign">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.location_manager')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item @click="selectMenuLocationAssign(0)" v-show="isAdmin">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.location[0].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuLocationAssign(1)" v-show="isViewAssignTeam">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.location[1].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuLocationAssign(2)" v-show="isViewAssignStaff">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.location[2].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>

            <template>
              <v-list-group prepend-icon="place" no-action v-show="isViewTarget">
                <template v-slot:activator >
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.target_management')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item @click="selectMenuTarget(0)">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.target[0].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuTarget(1)" v-show="false">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.target[1].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuTarget(2)" v-show="false">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.target[2].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>

            <template>
              <v-list-group prepend-icon="perm_contact_calendar" no-action v-show="isViewContact">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.contact_management')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item @click="selectMenuContact(0)" v-show="false">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.contact[0].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuContact(1)"  v-show="isViewCompetitor">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.contact[1].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>

            <template>
              <v-list-group prepend-icon="perm_contact_calendar" no-action v-show="isViewStaff">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.human_resource')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <!-- <v-list-item v-for="(subItem, index) in navigation.customer" :key="subItem.title" @click="selectMenuCustomer(index)">
                    <v-list-item-content>
                        <v-list-item-title v-text="subItem.title"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item> -->

                <v-list-item @click="selectMenuStaff(0)">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.staff[0].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuStaff(1)" v-show="isViewStaffCreated">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.staff[1].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuStaff(2)" v-show="isViewStaffApprove">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.staff[2].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuStaff(3)" v-show="isViewStaffInActive">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.staff[3].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>

            <v-list-item to="reportManagement" v-show="isViewReportManagement">
              <v-list-item-icon>
                <v-icon>event_note</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ $t('menu.report_management') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>


            <template>
              <v-list-group prepend-icon="supervisor_account" no-action v-show="isViewCustomer">
<!--                <v-list-group prepend-icon="supervisor_account" no-action v-show="isViewCustomer">-->
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.customer')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <!-- <v-list-item v-for="(subItem, index) in navigation.customer" :key="subItem.title" @click="selectMenuCustomer(index)">
                    <v-list-item-content>
                        <v-list-item-title v-text="subItem.title"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item> -->

                <v-list-item @click="selectMenuCustomer(0)" v-show="isViewCustomerList">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.customer[0].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuCustomer(1)" v-show="isViewCustomerType">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.customer[1].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

<!--                <v-list-item @click="selectMenuCustomer(2)" v-show="isViewOderUnit">-->
<!--                  <v-list-item-content>-->
<!--                    <v-list-item-title v-text="navigation.customer[2].title"></v-list-item-title>-->
<!--                  </v-list-item-content>-->
<!--                </v-list-item>-->
              </v-list-group>
            </template>

            <template>
              <v-list-group prepend-icon="widgets" no-action v-show="isViewMaterial">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.material_management')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="(subItem, index) in navigation.material" :key="subItem.title"
                             @click="selectMenuMaterail(index)">
                  <v-list-item-content>
                    <v-list-item-title v-text="subItem.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list-group>
            </template>

            <v-list-item to="giftManagement" v-show="isViewGift">
              <v-list-item-icon>
                <v-icon>card_giftcard</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ $t('menu.gift') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>


            <template>
              <v-list-group prepend-icon="local_shipping" no-action v-show="isViewLogisticRequest">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.logistic')"></v-list-item-title>
                  </v-list-item-content>
                </template>


                <v-list-item to="logisticUnitManagement" v-show="isViewLogisticUnit">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.logistic[0].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item to="logisticRequestManagement" v-show="isViewLogisticRequest">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.logistic[1].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>

            <template>
              <v-list-group prepend-icon="emoji_objects" no-action>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.idea')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item @click="selectMenuIdea(0)" v-show="isAdmin">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.idea[0].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuIdea(1)">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.idea[1].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuIdea(2)">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.idea[2].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>

            <template>
              <v-list-group prepend-icon="storefront" no-action v-show="isViewSale">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.listing')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="(subItem, index) in navigation.sale" :key="subItem.title"
                             @click="selectMenuSale(index)">
                  <v-list-item-content>
                    <v-list-item-title v-text="subItem.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list-group>
            </template>

            <template>
              <v-list-group prepend-icon="color_lens" no-action v-show="isViewDesigner">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.listing_designer')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="(subItem, index) in navigation.designer" :key="subItem.title"
                             @click="selectMenuDesigner(index)">
                  <v-list-item-content>
                    <v-list-item-title v-text="subItem.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list-group>
            </template>

            <template>
              <v-list-group prepend-icon="account_balance_wallet" no-action v-show="isViewAccountant">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.listing_accountant')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="(subItem, index) in navigation.accountant" :key="subItem.title"
                             @click="selectMenuAccountant(index)">
                  <v-list-item-content>
                    <v-list-item-title v-text="subItem.title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list-group>
            </template>

            <template>
              <v-list-group prepend-icon="insert_chart_outlined" no-action v-show="isViewStatistic">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title v-text="$t('menu.statistic')"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item @click="selectMenuStatistic(0)" v-show="isViewStatisticMetrix">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.statistic[0].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuStatistic(1)" v-show="isViewStatisticGeneral">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.statistic[1].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item @click="selectMenuStatistic(2)" v-show="isViewStatisticDesignScore">
                  <v-list-item-content>
                    <v-list-item-title v-text="navigation.statistic[2].title"></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list-group>
            </template>

            <v-list-item to="systemSetting" v-show="isViewSetting">
              <v-list-item-icon>
                <v-icon>settings</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ $t('menu.system_setting') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-navigation-drawer>
        <router-view/>
      </div>

    </v-main>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';
import VueJwtDecode from 'vue-jwt-decode';

import socketClient from '@/plugins/socketClient';

// import io from "socket.io-client";

export default {
  data: () => ({
    baseImage: process.env.VUE_APP_BASE_IMAGE,
    baseAttach: process.env.VUE_APP_BASE_ATTACH,

    menus: [
      {title: i18n.t('profile.title')},
      {title: i18n.t('changePass.title')},
      {title: i18n.t('menu.logout')},
    ],

    navigation: {
      organization: [
        // {title: i18n.t('menu.struct_management')},
        // {title: i18n.t('menu.room_management')},
        {title: i18n.t('menu.team_management')}
      ],

      permission: [
        // {title: i18n.t('menu.category')},
        // { title: i18n.t('menu.permision') },
        // { title: i18n.t('menu.perssion_assign') },
        {title: i18n.t('menu.job_management')}
      ],

      location: [
        {title: i18n.t('menu.department_assign')},
        {title: i18n.t('menu.team_assign')},
        {title: i18n.t('menu.staff_assign')}
      ],

      target: [
        {title: i18n.t('menu.order_unit_management')},
        {title: i18n.t('menu.target_list')},
        {title: i18n.t('menu.approve_target_list')}
      ],

      contact: [
        {title: i18n.t('menu.contact_list')},
        {title: i18n.t('menu.competitor_list')}
      ],

      staff: [
        {title: i18n.t('menu.active_staff')},
        {title: i18n.t('menu.new_staff')},
        {title: i18n.t('menu.approve_staff')},
        {title: i18n.t('menu.inactive_staff')}
      ],

      customer: [
        {title: i18n.t('menu.customer_list')},
        {title: i18n.t('menu.customer_type')},
        // {title: i18n.t('menu.order_unit')}
      ],

      material: [
        {title: i18n.t('menu.form_style')},
        {title: i18n.t('menu.material')},
        {title: i18n.t('menu.material_style')},
        {title: i18n.t('menu.metric')},
        {title: i18n.t('menu.print_style')},
        {title: i18n.t('menu.order_type')},
        {title: i18n.t('menu.profile')},
        {title: i18n.t('menu.size')}
      ],

      sale: [
        {title: i18n.t('menu.design_request')},
        {title: i18n.t('menu.production_request')},
        {title: i18n.t('menu.waiting_request')},
        {title: i18n.t('menu.finish_request')},
        {title: i18n.t('menu.teamplate_catalog')}
      ],

      designer: [
        {title: i18n.t('menu.design_request')},
        {title: i18n.t('menu.production_request')},
        {title: i18n.t('menu.waiting_request')},
        {title: i18n.t('menu.finish_request')},
      ],

      accountant: [
        {title: i18n.t('menu.production_request')},
        {title: i18n.t('menu.waiting_request')},
        {title: i18n.t('menu.pending_request')},
        {title: i18n.t('menu.finish_request')}
      ],

      idea: [
        {title: i18n.t('menu.idea_category')},
        {title: i18n.t('menu.idea_request_approve')},
        {title: i18n.t('menu.idea_request_public')}
      ],

      logistic: [
        {title: i18n.t('menu.logistic_unit')},
        {title: i18n.t('menu.logistic_request')}
      ],

      statistic: [
        {title: i18n.t('menu.statistic_materail_predict')},
        //   { title: i18n.t('menu.statistic_profit') },
        {title: i18n.t('menu.statistic_general')},
        {title: i18n.t('menu.statistic_score')},
      ],

      setting: [
        {title: i18n.t('menu.system_setting')}
      ]


    },

    saleTab: [
      {id: 0, name: i18n.t('menu.design_request'), link: '/designRequestManagement'},
      {id: 1, name: i18n.t('menu.production_request'), link: '/manufactureRequestManagement'},
      {id: 2, name: i18n.t('menu.waiting_request'), link: '/processingRequestManagement'},
      {id: 3, name: i18n.t('menu.finish_request'), link: '/finishRequestManagement'},
    ],

    disabled: false,
    absolute: false,
    openOnHover: false,
    value: false,
    closeOnClick: true,
    closeOnContentClick: true,
    offsetX: false,
    offsetY: true,
    drawer: false,
    group: null,
    user: {},
    avatar: '',
    arrayJobs: [],
    job: {},

    totalNumber: 0,
    numberManufactureRequest: 0,
    numberDesignRequest: 0,
    numberShipRequest: 0,
    numberFinishRequest: 0,
    numberProcessingRequest: 0,
    numberPendingRequest: 0,

    isViewOrganization: false,
    isViewPermission: false,

    isViewCustomer: false,
    isViewCustomerList: false,
    isViewCustomerType: false,
    isViewOderUnit: false,

    isViewSale: false,
    isViewDesigner: false,
    isViewAccountant: false,
    isViewStaff: false,
    isViewStatistic: false,
    isViewStatisticMetrix: false,
    isViewStatisticGeneral: false,
    isViewStatisticDesignScore: false,
    isViewMaterial: false,
    isViewGift: false,
    isViewSetting: false,

    isViewStaffCreated: false,
    isViewStaffApprove: false,
    isViewStaffInActive: false,
    isViewReportManagement: false,

    isViewLogisticUnit: false,
    isViewLogisticRequest: false,

    isViewAssignTeam: false,
    isViewAssignStaff: false,

    isViewTarget: false,
    isViewLocationAssign: false,
    isViewContact: false,
    isViewCompetitor: false,

    isAdmin: false,
    tabSelect: 0,

    isConnected: false,
    socketMessage: ''
  }),


  watch: {
    group() {
      this.drawer = false
    }
  },

  methods: {
    selectItem: function (index) {
      if (index == 0) {
        this.$router.push('profile');
      } else if (index == 1) {
        this.$router.push('changePass');
      } else if (index == 2) {
        // this.$store.dispatch('login/setStateLogin', false);
        localStorage.removeItem('access_token');
        localStorage.removeItem('jobs');
        localStorage.removeItem('user_id');
        this.$router.push('/login');
      }
    },

    selectMenuOrganization(index) {
      // if (index == 0) {
      //   this.$router.push('blockManagement');
      // } else if (index == 1) {
      //   this.$router.push('departmentManagement');
      // } else if (index == 2) {
      //   this.$router.push('teamManagement');
      // }

      if (index == 0) {
        this.$router.push('teamManagement');
      }
    },

    selectMenuPermission(index) {
      // if (index == 0) {
      //   this.$router.push('categoryManagement');
      // }
      //     //  else if (index == 1) {
      //     //     this.$router.push('permissionManagement');
      //     // } else if (index == 2) {
      //     //     this.$router.push('permissionAssign');
      // // }
      // else if (index == 1) {
      //   this.$router.push('jobManagement');
      // }

      if (index == 0) {
        this.$router.push('jobManagement');
      }
    },

    selectMenuCustomer(index) {
      if (index == 0) {
        this.$router.push('customerManagement');
      } else if (index == 1) {
        this.$router.push('customerType');
      }
      // else if (index == 2) {
      //   this.$router.push('orderUnitManagement');
      // }
    },

    selectMenuIdea(index) {
      if (index == 0) {
        this.$router.push('ideaCategory');
      } else if (index == 1) {
        this.$router.push('ideaRequestApprove');
      } else if (index == 2) {
        this.$router.push('ideaRequestManagement');
      }
    },

    selectMenuStaff(index) {
      if (index == 0) {
        this.$router.push('staffManagement');
      } else if (index == 1) {
        this.$router.push('createdStaffManagement');
      } else if (index == 2) {
        this.$router.push('approveStaffManagement');
      } else if (index == 3) {
        this.$router.push('retireStaffManagement');
      }
    },

    selectMenuLocationAssign(index) {
      if (index == 0) {
        this.$router.push('departmentsAssign');
      } else if (index == 1) {
        this.$router.push('teamAssign');
      } else if (index == 2) {
        this.$router.push('staffAssign');
      }
    },

    selectMenuContact(index) {
      if (index == 0) {
        this.$router.push('contactManagement');
      } else if (index == 1) {
        this.$router.push('competitorManagement');
      }
    },

    selectMenuTarget(index) {
      if (index == 0) {
        this.$router.push('orderUnitManagement');
      } else if (index == 1) {
        this.$router.push('targetManagement');
      } else {
        this.$router.push('approveTargetManagement');
      }
    },

    selectMenuMaterail(index) {
      if (index == 0) {
        this.$router.push('formStyleManagement');
      } else if (index == 1) {
        this.$router.push('materialManagement');
      } else if (index == 2) {
        this.$router.push('materialStyleManagement');
      } else if (index == 3) {
        this.$router.push('metricManagement');
      } else if (index == 4) {
        this.$router.push('printStyleManagment');
      } else if (index == 5) {
        this.$router.push('orderTypeManagement');
      } else if (index == 6) {
        this.$router.push('profileManagement');
      } else if (index == 7) {
        this.$router.push('sizeManagement');
      }
    },

    selectMenuSale(index) {
      if (index == 0) {
        this.$router.push('designRequestManagement');
      } else if (index == 1) {
        this.$router.push('manufactureRequestManagement');
      } else if (index == 2) {
        this.$router.push('processingRequestManagement');
      } else if (index == 3) {
        this.$router.push('finishRequestManagement');
      } else if (index == 4) {
        this.$router.push('templateCatalog');
      }
    },

    selectMenuDesigner(index) {
      if (index == 0) {
        this.$router.push('designerDesignRequest');
      } else if (index == 1) {
        this.$router.push('designerManufactureRequest');
      } else if (index == 2) {
        this.$router.push('designerProcessingRequest');
      } else if (index == 3) {
        this.$router.push('designerFinishedRequest');
      }
    },

    selectMenuAccountant(index) {
      if (index == 0) {
        this.$router.push('accountantManufactureRequest');
      } else if (index == 1) {
        this.$router.push('accountantProcessingRequest');
      } else if (index == 2) {
        this.$router.push('accountantPendingRequest');
      } else if (index == 3) {
        this.$router.push('accountantFinishRequest');
      }
    },

    selectMenuStatistic(index) {
      if (index == 0) {
        this.$router.push('materialStatistic');
      } else if (index == 1) {
        // this.$router.push('profitStatistic');
        this.$router.push('designRequestStatistic');
      } else if (index == 2) {
        this.$router.push('designerScoreStatistic');
      }
    },

    checkShowMenuView() {
      if (this.user) {
        if (this.user._id == '5e0a2c14c3b2755585aee617') { //admin
          localStorage.setItem('isAdmin', true);

          this.isViewOrganization = true;
          this.isViewPermission = true;
          this.isViewCustomer = true;
          this.isViewCustomerType = true;
          this.isViewCustomerList = true;
          this.isViewOderUnit = true;

          this.isViewSale = true;
          this.isViewDesigner = true;
          this.isViewAccountant = true;
          this.isViewStaff = true;
          this.isViewStatistic = true;
          this.isViewMaterial = true;
          this.isViewGift = true;
          this.isViewSetting = true;
          this.isViewReportManagement = false;

          this.isViewStaffCreated = false;
          this.isViewStaffApprove = true;
          this.isViewStaffInActive = true;

          this.isViewStatisticMetrix = true;
          this.isViewStatisticGeneral = true;
          this.isViewStatisticDesignScore = true;
          this.isViewLogisticUnit = true;
          this.isViewLogisticRequest = true;
          this.isViewAssignTeam = true;
          this.isViewAssignStaff = true;
          this.isViewCompetitor = true;

          this.isViewLocationAssign = true;
          this.isViewTarget = true;
          this.isViewContact = true;
          this.isViewCompetitor = true;


          this.isAdmin = true;
          this.$router.push('staffManagement');
          return;
        }

        localStorage.setItem('isAdmin', false);
        // this.arrayJobs.forEach(job => {
        if (this.job.category == 5) {//ceo
          this.isViewOrganization = false;
          this.isViewPermission = false;
          this.isViewCustomer = false;
          this.isViewCustomerType = false;
          this.isViewCustomerList = false;
          this.isViewOderUnit = false;

          this.isViewCustomerType = false;
          this.isViewSale = false;
          this.isViewDesigner = false;
          this.isViewAccountant = false;

          this.isViewStaff = true;
          this.isViewStaffCreated = true;
          this.isViewStaffApprove = true;
          this.isViewStaffInActive = true;
          this.isViewReportManagement = false;

          this.isViewStatistic = true;
          this.isViewStatisticMetrix = true;
          this.isViewStatisticGeneral = true;
          this.isViewStatisticDesignScore = true;

          this.isViewLogisticUnit = false;
          this.isViewLogisticRequest = false;

          this.isViewTarget = true;
          this.isViewContact = true;
          this.isViewCompetitor = true;
          this.isViewLocationAssign = true;

          this.isViewMaterial = false;
          this.isViewGift = false;
          this.isViewSetting = false;
          this.$router.push('materialStatistic');
          return;
        }

        if (this.job.type == 4) {//logistic
          this.isViewOrganization = false;
          this.isViewPermission = false;
          this.isViewCustomer = false;
          this.isViewCustomerType = false;
          this.isViewSale = false;
          this.isViewDesigner = false;
          this.isViewAccountant = false;

          this.isViewStatistic = false;
          this.isViewMaterial = false;
          this.isViewGift = false;
          this.isViewSetting = false;

          this.isViewStaff = false;
          this.isViewStaffCreated = false;
          this.isViewStaffApprove = false;
          this.isViewStaffInActive = false;

          this.isViewStatisticMetrix = false;
          this.isViewStatisticGeneral = false;
          this.isViewStatisticDesignScore = false;

          this.isViewLogisticUnit = false;
          this.isViewReportManagement = false;

          this.isViewLogisticRequest = true;
          this.isViewTarget = false;
          this.isViewContact = false;
          this.isViewCompetitor = false;
          this.isViewLocationAssign = false;

          if (this.job.category == 2) {
            this.isViewStaff = true;
            this.isViewStaffCreated = true;
            this.isViewStaffApprove = false;
            this.isViewStaffInActive = false;
          } else if (this.job.category == 3) {
            this.isViewStaff = true;
            this.isViewStaffCreated = false;
            this.isViewStaffApprove = true;
            this.isViewStaffInActive = true;
          } else if (this.job.category == 4) {
            this.isViewStaff = true;
            this.isViewStaffCreated = false;
            this.isViewStaffApprove = true;
            this.isViewStaffInActive = true;
          }

          this.$router.push('logisticRequestManagement');
        } else if (this.job.type == 3) {//accountant
          this.isViewOrganization = false;
          this.isViewPermission = false;
          this.isViewCustomer = false;
          this.isViewCustomerType = false;
          this.isViewSale = false;
          this.isViewDesigner = false;
          this.isViewAccountant = true;

          this.isViewStatistic = false;
          this.isViewMaterial = false;
          this.isViewGift = false;
          this.isViewSetting = false;

          this.isViewStaff = false;
          this.isViewStaffCreated = false;
          this.isViewStaffApprove = false;
          this.isViewStaffInActive = false;

          this.isViewStatisticMetrix = false;
          this.isViewStatisticGeneral = false;
          this.isViewStatisticDesignScore = false;

          this.isViewLogisticUnit = false;
          this.isViewReportManagement = false;
          this.isViewLogisticRequest = false;
          this.isViewCompetitor = false;

          if (this.job.category == 2) {
            this.isViewStaff = true;
            this.isViewStaffCreated = true;
            this.isViewStaffApprove = false;
            this.isViewStaffInActive = false;
          } else if (this.job.category == 3) {
            this.isViewStaff = true;
            this.isViewStaffCreated = false;
            this.isViewStaffApprove = true;
            this.isViewStaffInActive = true;
          } else if (this.job.category == 4) {
            this.isViewStaff = true;
            this.isViewStaffCreated = false;
            this.isViewStaffApprove = true;
            this.isViewStaffInActive = true;
          }

          this.$router.push('accountantManufactureRequest');
        } else if (this.job.type == 2) {//designer
          this.isViewOrganization = false;
          this.isViewPermission = false;
          this.isViewCustomer = false;
          this.isViewCustomerType = false;
          this.isViewSale = false;
          this.isViewDesigner = true;
          this.isViewAccountant = false;
          this.isViewStaff = false;
          this.isViewStatistic = false;
          this.isViewMaterial = false;
          this.isViewGift = false;
          this.isViewSetting = false;

          this.isViewReportManagement = false;
          this.isViewStatisticMetrix = false;
          this.isViewStatisticGeneral = false;
          this.isViewStatisticDesignScore = false;
          this.isViewLogisticUnit = false;
          this.isViewLogisticRequest = false;

          this.isViewTarget = false;
          this.isViewContact = false;
          this.isViewCompetitor = false;
          this.isViewLocationAssign = false;

          if (this.job.category == 2) {
            this.isViewStaff = true;
            this.isViewStaffCreated = true;
            this.isViewStaffApprove = false;
            this.isViewStaffInActive = false;
          } else if (this.job.category == 3) {
            this.isViewStaff = true;
            this.isViewStaffCreated = false;
            this.isViewStaffApprove = true;
            this.isViewStaffInActive = true;
            this.isViewReportManagement = true;
          } else if (this.job.category == 4) {
            this.isViewStaff = true;
            this.isViewStaffCreated = false;
            this.isViewStaffApprove = true;
            this.isViewStaffInActive = true;
            this.isViewReportManagement = true;
          }

          this.$router.push('designerDesignRequest');
        } else if (this.job.type == 1) {//sale
          this.isViewOrganization = false;
          this.isViewPermission = false;

          this.isViewCustomer = false;
          this.isViewCustomerType = false;
          this.isViewCustomerList = false;
          this.isViewOderUnit = false;

          this.isViewSale = true;
          this.isViewDesigner = false;
          this.isViewAccountant = false;
          this.isViewStaff = false;
          this.isViewStatistic = false;
          this.isViewMaterial = false;
          this.isViewGift = false;
          this.isViewSetting = false;
          this.isViewLogisticRequest = false;

          this.isViewStatisticMetrix = false;
          this.isViewStatisticGeneral = false;
          this.isViewStatisticDesignScore = false;

          this.isViewReportManagement = false;
          this.isViewLogisticUnit = false;

          this.isViewAssignTeam = false;
          this.isViewAssignStaff = false;

          this.isViewTarget = true;
          this.isViewContact = false;
          this.isViewCompetitor = false;
          this.isViewLocationAssign = false;

          if (this.job.category == 2) {
            this.isViewStaff = true;
            this.isViewStaffCreated = true;
            this.isViewStaffApprove = false;
            this.isViewStaffInActive = false;
            this.isViewStatistic = true;
            this.isViewStatisticGeneral = true;
            this.isViewLogisticUnit = true;

            this.isViewCustomer = true;
            this.isViewOderUnit = true;
            this.isViewAssignStaff = true;

            this.isViewTarget = true;
            this.isViewContact = true;
            this.isViewCompetitor = true;
            this.isViewLocationAssign = true;
          } else if (this.job.category == 3) {
            this.isViewStaff = true;
            this.isViewStaffCreated = false;
            this.isViewStaffApprove = true;
            this.isViewStaffInActive = true;
            this.isViewReportManagement = true;
            this.isViewStatistic = true;
            this.isViewStatisticGeneral = true;

            this.isViewCustomer = true;
            this.isViewOderUnit = true;
            this.isViewAssignTeam = true;
            this.isViewAssignStaff = true;

            this.isViewTarget = true;
            this.isViewContact = true;
            this.isViewCompetitor = true;
            this.isViewLocationAssign = true;
          } else if (this.job.category == 4) {
            this.isViewStaff = true;
            this.isViewStaffCreated = false;
            this.isViewStaffApprove = true;
            this.isViewStaffInActive = true;
            this.isViewReportManagement = true;
            this.isViewStatistic = true;
            this.isViewStatisticGeneral = true;

            this.isViewCustomer = true;
            this.isViewOderUnit = true;
            this.isViewAssignTeam = true;
            this.isViewAssignStaff = true;

            this.isViewTarget = true;
            this.isViewContact = true;
            this.isViewCompetitor = true;
            this.isViewLocationAssign = true;
          }

          this.$router.push('designRequestManagement');
        }
        // });
      }
    },

    async getTotalNumberOfNotification() {
      var response;
      if (this.job.type == 4) {//logistic
        response = await this.$http.get(process.env.VUE_APP_EVENT_LOG_API + 'logistic/total');
        // console.log(response);
      } else if (this.job.type == 3) {//accountant
        response = await this.$http.get(process.env.VUE_APP_EVENT_LOG_API + 'accountant/total');
        // console.log(response);
      } else if (this.job.type == 2 || this.job.type == 1) {
        response = await this.$http.get(process.env.VUE_APP_EVENT_LOG_API + 'targetUser/total/' + this.user._id);
        // console.log(response);
      }

      if (response && response.data.success) {
        this.totalNumber = response.data.total;
      }
    },

    async getNumberOfUnreadDesignRequest() {
      if (this.isAdmin) {
        return 0;
      }

      const response = await this.$http.get(process.env.VUE_APP_UNREAD_DESIGN_API + this.user._id);

      if (response && response.data.success) {
        this.numberDesignRequest = response.data.data.totalRequestUnread;
      }
    },

    async getNumberOfUnreadManfufactureRequest(status) {
      if (this.isAdmin || !this.user) {
        return 0;
      }

      const response = await this.$http.get(process.env.VUE_APP_UNREAD_MANUFACTURE_API + this.user._id + '?status=' + status);

      if (response && response.data.success) {
        return response.data.data.totalRequestUnread;
      }
    },

    async updateTotalNotify() {
      var response;
      if (this.job.type == 4) {//logistic
        response = await this.$http.put(process.env.VUE_APP_EVENT_LOG_API + 'logisticStatus/');
        // console.log(response);
      } else if (this.job.type == 3) {//accountant
        response = await this.$http.put(process.env.VUE_APP_EVENT_LOG_API + 'accountantStatus/');
        // console.log(response);
      } else if (this.job.type == 2 || this.job.type == 1) {
        response = await this.$http.put(process.env.VUE_APP_EVENT_LOG_API + 'targetUserStatus/' + this.user._id);
        // console.log(response);
      }
      if (response.data.success) {
        this.totalNumber = 0;
      }
    }
  },
  async created() {
    const dataUser = VueJwtDecode.decode(localStorage.getItem('access_token'));
    localStorage.setItem('user_id', dataUser.data._id);
    let socket;

    if (!this.isAdmin) {
      socket = await socketClient.createConnection();
      const identify = dataUser.data._id;

      socket.on('connect', function () {
        if (socketClient.getIO().connected) {
          socketClient.getIO().emit('REGISTER_CONNECTION', identify);
        }
      });
    }
    try {
      const response = await this.$http.get(`${process.env.VUE_APP_GET_USER_URL}/${dataUser.data._id}`);
      if (response.data && response.data.success) {
        console.log(response.data);

        this.user = response.data.data;

        if (this.user.avatar) {
          this.avatar = this.baseImage + this.user.avatar + "/50/50";
        }

        if (this.user.job && this.user.job.category) {
          this.job.category = this.user.job.category.type;

          if (this.job.category !== 5) {
            if (Array.isArray(this.user.job.context.parents) && this.user.job.context.parents.length > 0) {
              this.job.type = this.user.job.context.parents[0].type;
            } else {
              this.job.type = this.user.job.context.type;
            }

            localStorage.setItem('category', this.job.category);
            localStorage.setItem('type', this.job.type);
            localStorage.setItem('context_id', this.user.job.context._id);
          }
        }

        this.checkShowMenuView();
        if (!this.isAdmin || socketClient.getIO().connected) {

          socket.on('UPDATE_DESIGN_REQUEST', () => {
            this.getNumberOfUnreadDesignRequest();
          });

          socket.on('CREATE_MANUFACTURE_REQUEST', async() => {
            this.numberManufactureRequest = await this.getNumberOfUnreadManfufactureRequest(1);
          });

          socket.on('EDIT_CREATED_MANUFACTURE_REQUEST', async() => {
            this.numberManufactureRequest = await this.getNumberOfUnreadManfufactureRequest(1);
          });

          socket.on('EDIT_PROCESSING_MANUFACTURE_REQUEST', async() => {
            this.numberProcessingRequest = await this.getNumberOfUnreadManfufactureRequest(2);
          });

          socket.on('EDIT_PENDING_MANUFACTURE_REQUEST', async() => {
            this.numberPendingRequest = await this.getNumberOfUnreadManfufactureRequest(3);
          });

          socket.on('ACCOUNTANT_APPROVE_MANUFACTURE_REQUEST', async() => {
            if (this.job.type == 2) {//designer
              this.numberManufactureRequest = await this.getNumberOfUnreadManfufactureRequest(1);
            } else {
              this.numberProcessingRequest = await this.getNumberOfUnreadManfufactureRequest(2);
            }
          });

          socket.on('DESIGN_APPROVE_MANUFACTURE_REQUEST', async() => {
            if (this.job.type == 3) {//designer
              this.numberManufactureRequest = await this.getNumberOfUnreadManfufactureRequest(1);
            } else {
              this.numberProcessingRequest = await this.getNumberOfUnreadManfufactureRequest(2);
            }
          });

          socket.on('MANUFACTURE_REQUEST_FINISH', async() => {
            this.numberFinishRequest = await this.getNumberOfUnreadManfufactureRequest(4);
          });

          socket.on('CREATE_SHIP_REQUEST', async() => {
            this.numberShipRequest = await this.getNumberOfUnreadManfufactureRequest(1);
          });

          socket.on('UPDATE_SHIP_REQUEST', async() => {
            this.numberFinishRequest = await this.getNumberOfUnreadManfufactureRequest(4);
          });

          await this.getTotalNumberOfNotification();

          await this.getNumberOfUnreadDesignRequest();

          this.numberManufactureRequest = await this.getNumberOfUnreadManfufactureRequest(1);
          this.numberProcessingRequest = await this.getNumberOfUnreadManfufactureRequest(2);
          this.numberPendingRequest = await this.getNumberOfUnreadManfufactureRequest(3);
          this.numberFinishRequest = await this.getNumberOfUnreadManfufactureRequest(4);
        }
      }
    } catch (e) {
      console.log(e.stack);
    }
  }
}
</script>


<style>
.titleName {
  width: 150px;
  text-align: end;
  margin-right: 10px;
}

.linkText {
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  color: #F08942;
}

.timeoutText {
  color: #FF0000;
}

.freelancerText {
  color: #33CAFF;
}

.saleText {
  color: #0C8F4D;
}


.unreadText {
  font-weight: bold;
}

.readText {
  font-weight: normal;
}

.contentTitle {
  display: inline-block;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.header-title {
  color: #1D243E;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
}

.text-title {
  color: #1D243E;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
}

.contentName {
  display: inline-block;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.contentAddress {
  display: inline-block;
  max-width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subTitleStyle {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  color: #6C738D;
}
</style>